import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=62469c36&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports